<template>
    <div class="com-footer" style="margin-top:50px;">
        <div class="com-footer-top-box clearfix">
            <div class="com-footer-top-item">
                <h3>合作和帮助</h3>
                <p><a  href="http://open.qq.com/" target="_blank" >开放平台</a></p>
                <p><a id="J_api" href="//sj.qq.com/api/index.html" target="_blank">一键安装</a></p>
                <p><a  href="//sj.qq.com/links.html" target="_blank">友情链接</a></p>
            </div>
            <div class="com-footer-top-item">
                <h3>产品动态</h3>
                <p><a id="J_intro" href="//sj.qq.com/intro.html" target="_blank">功能介绍</a></p>
                <p><a id="J_root" href="//sj.qq.com/root/index.html" target="_blank">一键Root</a></p>
                <p><a id="J_shuaji" href="//sj.qq.com/shuaji/index.html" target="_blank">一键刷机</a></p>
            </div>

            <div class="com-footer-top-item">
                <div class="erwm"></div>
                <h3>联系我们</h3>
                <p class="com-footer-contus">QQ     群：218938467</p>
                <p class="com-footer-contus">官方微博：<a class="qqweibo" target="_blank" href="http://e.t.qq.com/download_app"></a><a class="xinlaweibo" href="//e.weibo.com/downloadapp" target="_blank"></a></p>
                <p>微信公众账号：应用宝</p>
            </div>
            <div class="clear"></div>
        </div>

        <div class="office-info" style="text-align:center; line-height:50px; margin-top:20px;">
            深圳市腾讯计算机系统有限公司 &nbsp;&nbsp;&nbsp;&nbsp;
            <a style="color:#989898" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030002000001"><span>粤公网安备 44030002000001号</span>&nbsp;<img style="vertical-align: text-bottom;" src="//mat1.gtimg.com/www/images/qq2012/icon_yuewangga1.png" width="16" height="16"></a>
        </div>

        <div class="com-footer-center-container" style="padding-top:20px;">

            <a hrer="//www.tencent.com/zh-cn/index.shtml" target="_blank">关于腾讯</a>|
            <a href="//www.tencent.com/en-us/index.shtml" target="_blank">About Tencent</a>|
            <a href="//www.qq.com/contract.shtml" target="_blank">服务条款</a>|
            <a href="http://wiki.open.qq.com/index.php?title=%E7%A7%BB%E5%8A%A8%E5%BA%94%E7%94%A8%E4%BE%B5%E6%9D%83%E6%8A%95%E8%AF%89%E6%8C%87%E5%BC%95" target="_blank">侵权投诉指引</a>|
            <a href="//www.tencent.com/zh-cn/at/contactus.shtml" target="_blank">商务洽谈</a>|
            <a href="//hr.tencent.com/" target="_blank">腾讯招聘</a>|
            <a href="//gongyi.qq.com/" target="_blank">腾讯公益</a>|
            <a href="//www.tencent.com/zh-cn/le/copyrightstatement.shtml" target="_blank">版权所有</a>
            <div>Copyright © 2012 - 2018 Tencent. All Rights Reserved.</div>
            <div class="security clearfix">
                <p>
                <span class="fl"><a href="http://www.sznet110.gov.cn/netalarm/index.jsp" target="_blank" rel="nofollow"><img width="44" height="50" border="0" alt="深圳网络警察报警平台" :src="`${imgRand[5]}${assets}/images${source}/common/police.png`"></a></span>
                <span class="fr"><a href="http://www.sznet110.gov.cn/netalarm/index.jsp" target="_blank" rel="nofollow">深圳网络警<br>
                    察报警平台</a></span>
                </p>
                <p>
                <span class="fl"><a href="http://www.sznet110.gov.cn/webrecord/innernet/Welcome.jsp?bano=4403101010155" target="_blank" rel="nofollow"><img width="41" height="49" border="0" alt="公共信息安全网络监察" :src="`${imgRand[5]}${assets}/images${source}/common/security.png`"></a></span>
                <span class="fr"><a href="http://www.sznet110.gov.cn/webrecord/innernet/Welcome.jsp?bano=4403101010155" target="_blank" rel="nofollow">公共信息安<br>
                    全网络监察</a></span>
                </p>
                <p>
                <span class="fl"><a href="http://white.anva.org.cn/" target="_blank" rel="nofollow"><img width="48" height="48" border="0" alt="中国互联网协会认证标志" :src="`${imgRand[5]}${assets}/images${source}/common/anva-c.png`"></a></span>
                </p>
                <p>
                <span class="fl"><a href="http://white.anva.org.cn/" target="_blank" rel="nofollow"><img width="48" height="48" border="0" alt="中国互联网协会认证标志" :src="`${imgRand[5]}${assets}/images${source}/common/anva-e.png`"></a></span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'footer-common',
  props: ['imgRand', 'assets', 'source']
};
</script>
